import { Link } from "@mui/icons-material";
import { Box } from "@mui/material";
import { Position } from "geojson";

import { FIELDWORKER_COLORS } from "~/config/statusColors";
import { GaiaMapMarker } from "~/modules/map/components/GaiaMapMarker";
import { fieldworkerLoadingAnimation } from "~/modules/plannerV2/components/IconFieldworker/fieldworker-loading-animation";

type GaiaMapMarkerFieldworkerDroppableProps = {
    coordinates: Position;
    loading?: boolean;
};

export function GaiaMapMarkerFieldworkerDroppable({ coordinates, loading }: GaiaMapMarkerFieldworkerDroppableProps) {
    return (
        <GaiaMapMarker coordinates={coordinates} offset={[-20, -20]}>
            <Box
                sx={{
                    padding: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: FIELDWORKER_COLORS.available,
                    borderRadius: "100%",
                    transition: "all .3s ease-in-out",
                    transform: "scale(1.3)",
                    animation: loading ? fieldworkerLoadingAnimation : null,
                    "@starting-style": {
                        transform: "scale(1)",
                    },
                }}
            >
                <Link sx={{ color: "white" }} />
            </Box>
        </GaiaMapMarker>
    );
}
